import { AnyAction } from 'redux';
import { roleInitialState, RoleState } from '@reducers/initialState/role';
import { roleActionTypes } from '@actions/actionTypes/role';
import _cloneDeep from 'lodash/cloneDeep';
import {
  FeaturePermission,
  PermissionActions,
  FeaturePermissionTitle,
  FeaturePermissionDescription,
} from '@enums';

export const roleReducer = (state = roleInitialState, action: AnyAction): RoleState => {
  switch (action.type) {
    case roleActionTypes.SET_ROLES: {
      return { ...state, roles: _cloneDeep(action.payload) };
    }
    case roleActionTypes.SET_ROLE_ID_FOR_DELETE: {
      return { ...state, roleIdForDelete: action.payload };
    }
    case roleActionTypes.DELETING_ROLE_LOADING: {
      return { ...state, isDeletingRoleLoading: action.payload };
    }
    case roleActionTypes.SET_CURRENT_ROLE_PERMISSIONS: {
      return { ...state, currentRolePermissions: _cloneDeep(action.payload) };
    }
    case roleActionTypes.SET_CURRENT_ROLE_PAGE_FEATURE_PERMISSIONS: {
      const currentRolePermissions = _cloneDeep(state.currentRolePermissions);
      const currentRolePermission = currentRolePermissions.find(
        ({ id }) => id === action.payload.pageId
      );
      const featurePermission = currentRolePermission.featurePermissions.find(
        ({ id }) => id === action.payload.featureId
      );
      featurePermission[PermissionActions.View] = action.payload.value;

      return { ...state, currentRolePermissions };
    }
    case roleActionTypes.SET_CURRENT_ROLE_PAGE_FEATURE_ACTION_PERMISSIONS: {
      const currentRolePermissions = _cloneDeep(state.currentRolePermissions);
      const currentRolePermission = currentRolePermissions.find(
        ({ id }) => id === action.payload.pageId
      );
      const featurePermission = currentRolePermission.featurePermissions.find(
        ({ id }) => id === action.payload.featureId
      );
      featurePermission[action.payload.action] = action.payload.value;

      return { ...state, currentRolePermissions };
    }
    case roleActionTypes.SET_CURRENT_ROLE_PAGE_GROUP_FEATURE_ACTION_PERMISSIONS: {
      const currentRolePermissions = _cloneDeep(state.currentRolePermissions);
      const currentPagePermission = currentRolePermissions.find(
        ({ id }) => id === action.payload.pageId
      );
      const featurePermission = currentPagePermission.featurePermissions.find(
        ({ instanceKey }) => instanceKey === action.payload.featureInstanceKey
      );
      if (featurePermission) {
        featurePermission[PermissionActions.View] = action.payload.value;
      } else {
        currentPagePermission.featurePermissions.push({
          name: FeaturePermission.GroupItem,
          instanceKey: action.payload.featureInstanceKey,
          [PermissionActions.View]: action.payload.value,
          [PermissionActions.Create]: null,
          [PermissionActions.Remove]: null,
          [PermissionActions.Update]: null,
          title: FeaturePermissionTitle.groupItem,
          description: FeaturePermissionDescription.groupItem,
        });
      }
      return { ...state, currentRolePermissions };
    }
    case roleActionTypes.SET_CURRENT_ROLE_PERMISSIONS_IS_SAVING: {
      return { ...state, isRolePermissionsSaving: action.payload.isSaving };
    }

    default: {
      return state;
    }
  }
};
